const CustomStepContent = ({ line1, line2 }) => (
  <div>
    <div>{line1}</div>
    <br></br>
    <div>{line2}</div>
  </div>
);

// Define the steps for the tour
export const baseTourComponentSteps = [
  {
    target: ".guided-tour-user-profile",
    title: "Welcome to LocusHub",
    content: (
      <CustomStepContent
        line1="We'll go through a quick tour of the application to familiarize you. This is your profile, which will allow you to change your settings or logout."
        line2="If you want to see this tour again, you can access it through your profile."
      />
    ),
    placement: "top",
    disableBeacon: true,
  },
  {
    target: ".guided-tour-menu",
    title: "Welcome to LocusHub",
    content: "Click the menu button to hide or expand the sidebar.",
    placement: "top",
    disableBeacon: true,
  },
  {
    target: ".guided-tour-nav-asset-management",
    title: "Welcome to LocusHub",
    content:
      "The Asset Management section allows you to view the details on all of the Locus robots in your business.",
    placement: "top",
    disableBeacon: true,
  },
  {
    target: ".guided-tour-nav-admin",
    title: "Welcome to LocusHub",
    content:
      "The Administration menu section allows you to manage information about the client, your users, and user permissions.",
    placement: "top",
    disableBeacon: true,
  },
  {
    target: ".guided-tour-nav-admin-users",
    title: "Welcome to LocusHub",
    content:
      "Under the Administration section are the Users and Permissions pages. These pages are where you manage the users for your site or business and includes the ability to enable or disable users.",
    placement: "top",
    disableBeacon: true,
  },
  {
    target: ".guided-tour-nav-help",
    title: "Welcome to LocusHub",
    content:
      "Under the Help section, you'll find information about new features, bug fixes, and the health status of all LocusHub services.",
    placement: "top",
    disableBeacon: true,
  },
  {
    target: ".guided-tour-nav-knowledge-base",
    title: "Welcome to LocusHub",
    content:
      "Also in the Help section, the Knowledge Base provides a wealth of useful information about the LocusHub application.",
    placement: "top",
    disableBeacon: true,
  },
  {
    target: ".guided-tour-help-icon",
    title: "Welcome to LocusHub",
    content:
      "The Help Button quickly takes you to Knowledge Base article for the page you're currently on.",
    placement: "top",
    disableBeacon: true,
  },
];

export const multiSiteTourComponentSteps = [
  {
    target: ".guided-tour-sites-selection",
    title: "Welcome to LocusHub",
    content:
      "As a multi-site user, you have the ability to view information about multiple Locus sites in your business. If you’d like to see information about a different site, use this dropdown to select it.",
    placement: "top",
    disableBeacon: true,
  },
];

export const dashboardReportTourComponentSteps = [
  {
    target: ".guided-tour-dashboard-report-selection",
    title: "Quick Note",
    content:
      "If there are other dashboards or reports available, you can access them here.",
    placement: "top",
    disableBeacon: true,
  },
];
